<template>
  <div class="simpleTable">
    <el-table
      ref="simpleTable"
      class="userlisttable"
      @select="selectAll"
      @select-all="selectAll"
      @cell-mouse-enter="cellMouseEnter"
      :data="tableData"
      :height="height"
      :row-class-name="tableRowClassName"
      :header-cell-class-name="headerCellClassName"
      :cell-class-name="cellClassName"
      :border="border"
      style="width: 100%">
      <el-table-column
        v-if="type"
        :type="type"
        :selectable="selectEnable"
        width="55">
      </el-table-column>
      <el-table-column :key="index" v-for="(item,index) in tableDataTitle" v-if="item.slot==undefined?true:false"
                       :prop="item.prop" :width='item.width+"px"' :label="item.label" show-overflow-tooltip>
        <template slot-scope="scope">
          <label @click="cellClick(scope.row,item.prop)">{{ scope.row[item.prop] }}</label>
        </template>
      </el-table-column>
      <slot :name="item.slot" v-else></slot>
      <!--<el-table-column>
        <template slot="header" slot-scope="scope">
        <el-input v-model="search" size="mini" placeholder="输入关键字搜索"/>
        </template>
        <template slot-scope="scope">
          <el-button type="primary">删除</el-button>
        </template>
      </el-table-column>-->
      <el-table-column v-if="tableOperates" label='操作'>
        <template slot-scope="scope">
          <div class="operatorArea">
            <div style="cursor:pointer;" v-show="item==='delete'" :key="index+new Date().getTime()+'a'"
                 v-for="(item,index) in tableOperates" @click="btnCallback('delete',scope.row)">
              <i style="color:#ff0000;margin-right:5px" class="el-icon-delete"></i><span style="color:#ff0000">删除</span>
            </div>
            <div style="cursor:pointer;" v-show="item==='edit'" :key="index+new Date().getTime()+'b'"
                 v-for="(item,index) in tableOperates" @click="btnCallback('edit',scope.row)">
              <i style="color:#3785f5;margin-right:5px" class="el-icon-edit"></i><span style="color:#3785f5">编辑</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="showPagination" class="pagination-box">
      <div class="fl total-cue">所有记录</div>
      <div class="fl total-cue">{{ pageTotal }}条</div>
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="currentPageSize"
        background
        :page-sizes="[10, 15, 20, 30, 40,100,200]"
        layout="sizes, prev, pager, next, jumper"
        :total="pageTotal"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleTable',
  data() {
    return {
      search: "",
      currentPage: 1,
      currentPageSize: 10,
      headerCellClassName: function () {
      },
      cellClassName: function () {
      }
    };
  },
  computed: {
    tableData() {
      return this.tableDataP;
    }
  },
  props: ['prepositiveSelects', 'pageTotal', 'showPagination', 'tableOperates', 'tableStyleName', 'tableDataTitle', 'tableDataP', 'tableRowClassName', 'height', 'type', 'border'],
  methods: {
//	      	cellClassName({row, column, rowIndex, columnIndex}){
//	      		console.log("这是第",rowIndex,"行")
//	      		if(rowIndex%2==0)
//	      		  return "cellName";
//	      	},
//	      	headerCellClassName({row,rowIndex}){
//	      		return 'headerClass';
//	      	},
//	      	tableRowClassName({row,rowIndex}){
//	      		console.log("此行row及Index",row,rowIndex)
//	      	},
    //多选禁用与否
    selectEnable(row, rowIndex) {
      if (row.selectable) {
        return true;
      } else {
        return false;
      }
    },
    //实现海选反选并能返回选中项。lastTableData为想选的数组,targetTableData要反选的目标群，targetKey是依据某唯一属性
    seaSelect(lastTableData, targetTableData, targetKey) {
      let needSelectedData = targetTableData.filter((targetTableDataItem, index) => {
        let temp = lastTableData.find((lastTableDataItem) => {
          return lastTableDataItem[targetKey] === targetTableDataItem[targetKey]
        })
        return temp ? true : false;
      })
      this.$nextTick(() => {
        if (needSelectedData) {
          needSelectedData.forEach(row => {
            this.$refs.simpleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.simpleTable.clearSelection();
        }
      })
      return needSelectedData;
    },
    //与海选反选相反的表格正向选择并能返回预选中项。prepositiveSelects为正向选择的预选数据。lastTableData为想选的数组，row为单点时所传入不是单点传undefined.targetKey为两者"沟通ID"，currentPageData为当前页数据必传
    positiveSelect(lastTableData, row, targetTableData, targetKey, currentPageData = []) {
      if (row) {
        //当先点击项是否为选中效果
        let isSelectedRow = lastTableData.find((item) => {
          return item[targetKey] === row[targetKey]
        })
        if (isSelectedRow) {//选中
          //目标中没有则放入tempNewtargetTableData，有则无需重复放入
          let isExist = targetTableData.find((item) => {
            return item[targetKey] === isSelectedRow[targetKey];
          })
          if (isExist) {
            console.log('选中的：有，无需放入')
          } else {
            this.prepositiveSelects.unshift(row);
          }
        } else {//点击项属于未选中
          //目标中没有则刚好没有，有则需要剔除该选中项
          let isExist = targetTableData.find((item) => {
            return item[targetKey] === row[targetKey];
          })
          if (isExist) {
            let index = this.prepositiveSelects.findIndex((item) => {
              return item[targetKey] === isExist[targetKey];
            })
            this.prepositiveSelects.splice(index, 1);
          } else {
            console.log('未选中：刚好没有不管')
          }
        }
      } else {//点击了全选按钮
        if (lastTableData.length != 0) {//全选
          console.log('wode pre呢', this.prepositiveSelects)
          lastTableData.forEach(lastTableDataItem => {
            let isExist = targetTableData.find((targetTableDataItem) => {
              return lastTableDataItem[targetKey] === targetTableDataItem[targetKey]
            })
            //如果目标群中存在了，则无需放入,不存在则放入
            if (isExist) {
              console.log('存在无需放入')
            } else {
              this.prepositiveSelects.unshift(lastTableDataItem);
            }
          })
        } else {//全不选，则当前页显示的如果目标群有就剔除。没有就刚好没有不操作
          if (currentPageData.length != 0) {
            let targetTableData = [...this.prepositiveSelects];
            let temp = targetTableData.filter((targetTableDataItem) => {
              let isExist = currentPageData.find((currentPageDataItem) => {
                return currentPageDataItem[targetKey] === targetTableDataItem[targetKey];
              })
              return isExist ? false : true
            })
            //避免在子组件中直接修改父组件对象采用的此法删除清空数组
            for (let i = 0; i < targetTableData.length; i++) {
              this.prepositiveSelects.splice(0, 1);
            }
            //把存在的放进去。此法也是避免子组件直接修改父组件
            for (let i = 0; i < temp.length; i++) {
              this.prepositiveSelects.push(temp[i]);
            }
          } else {
            console.log('表格无数据，不需正向选择')
          }
        }
      }
      return this.prepositiveSelects;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.$emit('page-change', this.currentPage, this.currentPageSize);
    },
    handleSizeChange(pageSize) {
      this.currentPageSize = pageSize;
      this.$emit('page-change', this.currentPage, this.currentPageSize);
    },
    cellMouseEnter(row, column, cell, event) {
      this.$emit('cell-mouse-enter', row, column, cell, event);
    },
    cellClick(row, column) {
      this.$emit("cellClick", row, column);
    },
    btnCallback(operatorType, row) {
      this.$emit('btnCallback', operatorType, row)
    },
    // 单选
    select(selection, row) {
      console.log("单选", selection, row);
      this.$emit("select", selection, row);
      this.$emit("whole-select", selection, row);
    },
    // 全选
    selectAll(selection) {
      // console.log("全选", selection);
      this.$emit("select-all", selection);
      this.$emit("whole-select", selection);
    }
  },
  created() {
    switch (this.tableStyleName) {
      case 'dialogTable':
        this.headerCellClassName = function ({row, column, rowIndex, columnIndex}) {
          return 'dialogHeader';
        }
        this.cellClassName = function ({row, column, rowIndex, columnIndex}) {
          return 'dialogCell'
        }
        break;
      case 'publicNumTable':
        this.headerCellClassName = ({row, rowIndex}) => {
          return 'publicNumTemplateHeader';
        }
        this.cellClassName = ({row, column, rowIndex, columnIndex}) => {
          if (columnIndex === 2) {
            return 'operator'
          }
          return 'publicNumTemplateCell';
        }
        break;
      default:
        break;
    }
  }
}
</script>

<style scoped>
.operatorArea {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
}

/* pagination样式 */
.total-cue {
  line-height: 30px;
  font-size: 12px;
  color: #46a0fc;
  margin-right: 10px;
}

.simpleTable .pagination-box {
  position: initial;
  width: 100%;
  padding: 0 20px;
  line-height: 37px;
  margin-top: 10px;
}

/*.el-table th{
	background-color: #409EFF;
	color:#E88F00;
	font-family: "微软雅黑";
}*/

/*第一类样式*/
.simpleTable >>> th[class~='headerClass'] {
  background-color: #409EFF;
  color: #E88F00;
  font-family: "微软雅黑";
}

.simpleTable >>> .cellName {
  background-color: #90EE90;
  color: #E88F00;
  font-family: "微软雅黑";
}

/*第二类样式*/
.simpleTable >>> th[class~='publicNumTemplateHeader'] {
  height: 40px;
  line-height: 40px;
  background-color: #ffffff;

  font-size: 14px;
}

.simpleTable >>> .publicNumTemplateCell {
  height: 40px;
  line-height: 40px;

  font-size: 14px;
}

.simpleTable >>> .operator label {
  cursor: pointer;

  font-size: 12px;
  color: #409EFF;
}

/* 第三类样式 */
.simpleTable >>> th[class~='dialogHeader'] {
  height: 4rem;
  line-height: 4rem;
  background-color: #f2f2f2;

  font-size: 1.6rem;
  text-align: center;
  color: #333333;
  font-weight: bolder;
}

.simpleTable >>> .dialogCell {
  height: 4rem;
  line-height: 4rem;
  font-size: 1.6rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/template/simpleTable.vue